export const USER_LOGIN_FORM_SUBMIT = 'USER_LOGIN_FORM_SUBMIT';

export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';

export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';

export const USER_LOGOUT = 'USER_LOGOUT';

export const SET_TOKEN = 'SET_TOKEN';

export const SET_USER_DATA = 'SET_USER_DATA';

export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';


// WEBPACK FOOTER //
// ./src/store/actions/types/userActionTypes.js